import { CoreEnv } from '@eventbrite/context-gen';
import { openInNewTab, setWindowLocation } from '@eventbrite/http';
import { EVENTBRITE } from '../constants';

export const openEventUrl = (url: string, ticketsBy = EVENTBRITE) => {
    if (ticketsBy === EVENTBRITE) {
        setWindowLocation(url);
    } else {
        openInNewTab(url);
    }
};

export const isProd = ({ env }: { env: CoreEnv }) => {
    return env.ebDomain.indexOf('eventbrite') > -1;
};
